import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { YDivider } from 'irmlib/styles'
import { uiGet } from 'irmlib/http'
import * as constants from 'irmlib/common/constants'
import { myJobsInfo } from '../../../../services/reports/jobStatistic'
import { getUser } from '../../../../redux/global'
import { isAdmin, isSupervisor, isSuperUser } from '../../../../common/functions'
import { LinksCardBody } from './Links'
import { BaseCard, CardBody } from './BaseCard'
import { myJobs } from '../../../../navigation/routePaths'
import { getFunctions, httpsCallable } from '../../../../utils/firestore'
import { getMyJobStatisticsForWorker } from '../../../../services/firestore/gdeJobs'
import { UpdateDistrict } from './UpdateDistrict'
// import { useTranslation } from 'react-i18next'

const myJobsDataEntryBackendKey = 'dataEntry'
const myJobsVerificationBackendKey = 'verification'
const myJobsTransmittedBackendKey = 'transmittedToday'
const myJobsUnassignedJobsBackendKey = 'unAssignedJobs'
const myJobsExceptionBoxBackendKey = 'exception'

const labelKeyDataEntry = 'dashBoard.dataEntry'
const labelKeyVerification = 'dashBoard.verification'
const labelKeyUnassignedJobs = 'dashBoard.unassignedJobs'
const labelKeyTransmittedToday = 'dashBoard.transmittedToday'
const labelKeyException = 'dashBoard.exception'

const defaultMyJobCardHeight = '234px'
const defaultDataEntryMyJobCardHeight = '274px'

const functions = getFunctions()

const adminSupervisorTemplate = [
  { backendKey: myJobsDataEntryBackendKey, label: labelKeyDataEntry, url: `${myJobs}?status=${constants.jobStatus.assigned}, ${constants.jobStatus.inProgress}` },
  { backendKey: myJobsVerificationBackendKey, label: labelKeyVerification, url: `${myJobs}?status=${constants.jobStatus.assigned}, ${constants.jobStatus.inProgress}` },
  { backendKey: myJobsExceptionBoxBackendKey, label: labelKeyException },
  { backendKey: myJobsTransmittedBackendKey, label: labelKeyTransmittedToday },
]

const userTemplate = [
  { backendKey: myJobsDataEntryBackendKey, label: labelKeyDataEntry, url: `${myJobs}?status=${constants.jobStatus.assigned}, ${constants.jobStatus.inProgress}` },
  { backendKey: myJobsVerificationBackendKey, label: labelKeyVerification, url: `${myJobs}?status=${constants.jobStatus.assigned}, ${constants.jobStatus.inProgress}` },
  { backendKey: myJobsUnassignedJobsBackendKey, label: labelKeyUnassignedJobs, url: `${myJobs}?status=${constants.jobStatus.assigned}` },
  { backendKey: myJobsExceptionBoxBackendKey, label: labelKeyException },
  { backendKey: myJobsTransmittedBackendKey, label: labelKeyTransmittedToday },
]

const headers = [
  { label: 'dashBoard.type', style: { width: '40%' } },
  { label: 'dashBoard.numberJobs', style: { width: '30%', textAlign: 'right' } },
  { label: 'dashBoard.numberBoxes', style: { width: '30%', textAlign: 'right' } },
]

const MyJobsContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const MyJobs = () => {
  // const { t } = useTranslation()
  const template = isAdmin() || isSupervisor() || isSuperUser() ? adminSupervisorTemplate : userTemplate
  const [data, setData] = useState(template.map(e => {
    return [
      { label: e.label, url: e.url },
      e.label === labelKeyTransmittedToday ? '' : '0',
      '0'
    ]
  }))

  const service = async () => {
    const { district, workerId } = getUser()
    let data = await getMyJobStatisticsForWorker(district, workerId)
    if (!data) {
      data = await myJobsInfo(district, workerId)
    }
    data = template.map(e => {
      return [
        { label: e.label, url: e.url },
        e.label === labelKeyException || data[e.backendKey] === undefined || data[e.backendKey].numOfJobs === undefined ? '-' : data[e.backendKey].numOfJobs,
        data[e.backendKey] === undefined || data[e.backendKey].totalBoxes === undefined ? '' : data[e.backendKey].totalBoxes
      ]
    })
    return data
  }

  useEffect(() => {
    const doGet = async () => {
      const data = await uiGet({ service })
      setData(data)
    }
    doGet()
  }, [])


  // function to handle myJobs data
  useEffect(() => {
    const { district, workerId } = getUser()
    const callabletransmit = httpsCallable(functions, 'grpGde-UpdateMyjobStatistics')
    callabletransmit({ district, workerId })
  }, [])

  return (
    <MyJobsContainer>
      <BaseCard
        height={isAdmin() || isSupervisor() || isSuperUser() ? defaultMyJobCardHeight : defaultDataEntryMyJobCardHeight}
        id='MyJobs'
        body={<><UpdateDistrict IsloginWithoutDistrict = {true}/><CardBody headers={headers} data={data} /></>} 
        title='dashBoard.myJobs'
        />
      {
        (isAdmin() || isSuperUser()) && <><YDivider height='20px' /><LinksCardBody /></>
      }
    </MyJobsContainer>
  )
}
